var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.506 6.588a.7.7 0 0 1 .99 0L12 11.093l4.505-4.505a.7.7 0 0 1 .99.99l-4.505 4.505 4.505 4.505a.7.7 0 0 1-.99.99L12 13.073l-4.505 4.505a.7.7 0 0 1-.99-.99l4.505-4.505-4.505-4.505a.7.7 0 0 1 0-.99",
  clipRule: "evenodd"
})));
export default SvgX;